<template>
  <vue-recaptcha
    ref="recaptcha"
    @verify="onVerify"
    @expired="onExpired"
    @reset="onReset"
    :sitekey="sitekey">
  </vue-recaptcha>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";

export default {
  name: 'Recaptcha',
  props: {},
  data() {
    return {
      sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY
    }
  },
  components: {
    'vue-recaptcha': VueRecaptcha
  },
  mounted() {
    // добавление в head скрипта google для капчи
    let recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit');
    document.head.appendChild(recaptchaScript);
  },
  created() {
  },
  methods: {
    onVerify: function (response) {
      this.$emit("recaptchaVerified", response);
    },
    onExpired: function () {
      this.resetRecaptcha();
      this.$emit("recaptchaExpired");
    },
    onReset: function () {
      this.resetRecaptcha();
      this.$emit("recaptchaReseted");
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset() // Direct call reset method
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->



<style lang="less" scoped>
  .registration {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .registration-form,
  .verification-form {
    width: 100%;
    text-align: left;

    &-errors,
    &-messages {
      width: 100%;
      margin-bottom: 1rem;

      & ul {
        list-style-type: none;
        padding: 0;
      }
    }
    &-errors {
      color: #640005;
    }
    &-messages {
      color: #24643b;
    }
    &-row {
      position: relative;
      margin-bottom: 0.8rem;

      &.required {

        &::after {
          content: "*";
          display: block;
          position: absolute;
          top: 0;
          right: 0.3rem;
          font-size: 1rem;
          color: #640005;
          pointer-events: none;
        }
      }
      &:last-of-type {
        margin-bottom: 0;
      }
    }
    & input[type=text] {
      width: 100%;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding: 0.5rem 0.8rem;
      border: 1px solid #efefef;
      border-radius: 5px;
      font-size: 1rem;
      outline: none;

      &:focus {
        border-color: #226095;
      }
    }
    &-halfinput {
      & input[type=text] {
        width: 50%;
      }
      & label,
      & a {
        display: inline-block;
        box-sizing: border-box;
        width: 50%;
        padding-left: 5%;
      }
    }
    &-checkbox {

      &-wrapper {
        width: 10%;
        padding: 0.3rem 0;
        display: inline-block;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        text-align: left;
        vertical-align: top;
      }
      & input[type=checkbox] {
        width: 1.5rem;
        height: 1.5rem;
        border: 1px solid #226095;
        border-radius: 5px;
        outline: none;
      }
      & label {
        width: 90%;
        display: inline-block;
        text-align: left;
      }
    }
    &-button {
      padding: 0.5rem 0.8rem;
      border: 1px solid #226095;
      border-radius: 5px;
      font-family: inherit;
      font-weight: inherit;
      color: #226095;
      background: transparent;
      margin: 0 0.8rem;
      outline: none;

      &:hover {
        text-decoration: underline;
      }
      &:active {
        background: #226095;
        color: #ffffff;
      }

      &Filled {
        background: #226095;
        color: #ffffff;

        &:hover {
          text-decoration: underline;
        }
        &:active {
          background: transparent;
          color: #226095;
        }
      }
      &:first-of-type {
        margin-left: 0;
      }
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
</style>
